<expanding-wrapper
  [initOpen]="!startClosed"
  [borderGreyOnCollapse]="false"
  [expandedState]="closed ? 'collapse' : 'expand'"
  [manualToggle]="true"
  [ngClass]="{collapse: closed}"
  (onToggle)="toggle.emit()"
>
  <div class="header-left"><h4>{{ title }}</h4></div>
  <div class="grid" [ngStyle]="{'grid-template-columns': gridTemplateColumns }">
    <div class="header"></div>
    <ng-container *ngFor="let column of columns">
      <div class="header">
        <span [innerHTML]="column.title" ></span>
      </div>
    </ng-container>
    <ng-container *ngFor="let row of rows; index as index;">
      <div class="row" [ngClass]="{ even: index%2 === 0 }">
        <div class="first-col">
          {{ row.title }}
        </div>
        <ng-container *ngFor="let column of columns;">
          <div class="cell body" *ngIf="{ data: data[column.key] ? data[column.key][row.key] : null } as vars">
            <div style="flex: 1"></div>
            <div class="inner-cell">
              <ng-container *ngIf="!!vars.data">{{ vars.data | prettyNumbers:2:1:true }}</ng-container>
              <ng-container *ngIf="!vars.data"> - </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</expanding-wrapper>


